import type { Rule } from './rule'

export class NotRule implements Rule {
  constructor(private rule: Rule) {}

  public isValid(): boolean {
    return !this.rule.isValid()
  }
}
